<script>import { createEventDispatcher } from "svelte";
const dispatch = createEventDispatcher();
export let horizontal = false;
export let sections = [];
export let activeSectionKey;
let textContainer = null;
let sliderPosition = 0;
let textContainerPosition = 0;
const containerSize = 150;
const sectionSize = containerSize / sections.length;
const sliderSize = sections.length > 6 ? 15 : containerSize / sections.length;
let activeSection;
let updatedSectionList = [];
$: {
  if (sections.length > 0) {
    updatedSectionList = markSections(sections);
    if (updatedSectionList.length > 0) {
      saveToLocalStorage(updatedSectionList);
    }
  }
}
$:
  if (activeSectionKey && updatedSectionList.length > 0) {
    const foundSection = sections.find((section) => section.key === activeSectionKey);
    if (foundSection) {
      activeSection = foundSection;
      const index = sections.indexOf(foundSection);
      handleSlider(index, foundSection.id);
    }
  }
const saveToLocalStorage = (sections2) => {
  localStorage.setItem("store-section-list", JSON.stringify(sections2));
};
const markSections = (sections2) => {
  const storedSections = JSON.parse(
    localStorage.getItem("store-section-list") || "[]"
  );
  return sections2.map((section) => {
    const storedSection = storedSections.find((s) => s.id === section.id);
    return {
      ...section,
      notVisited: storedSection ? storedSection.notVisited : true
    };
  });
};
const setNotVisited = (id) => {
  const newList = updatedSectionList.map((section) => {
    if (section.id === id) {
      return { ...section, notVisited: false };
    }
    return section;
  });
  updatedSectionList = newList;
  saveToLocalStorage(updatedSectionList);
};
const handleSlider = (index, id) => {
  moveSliderToSection(index);
  setNotVisited(id);
};
const onClickSection = (key) => {
  activeSectionKey = key;
  dispatch("clickedSection", key);
};
const moveSliderToSection = (index) => {
  if (textContainer) {
    if (index === 0) {
      sliderPosition = 0;
      textContainerPosition = 0;
    } else if (index === sections.length - 1) {
      sliderPosition = containerSize - sliderSize;
      textContainerPosition = horizontal ? containerSize - textContainer.clientWidth : containerSize - textContainer.clientHeight;
    } else {
      sliderPosition = sectionSize * index + sectionSize / 2 - sliderSize / 2;
      const textPosition = horizontal ? sectionSize * index + sectionSize / 2 - textContainer.clientWidth / 2 : sectionSize * index + sectionSize / 2 - textContainer.clientHeight / 2;
      if (horizontal) {
        if (textPosition > containerSize - textContainer.clientWidth) {
          textContainerPosition = containerSize - textContainer.clientWidth;
        } else {
          textContainerPosition = textPosition;
        }
      } else {
        if (textPosition > containerSize - textContainer.clientHeight) {
          textContainerPosition = containerSize - textContainer.clientHeight;
        } else {
          textContainerPosition = textPosition;
        }
      }
    }
  }
};
const formatDate = (publishedAt) => {
  const today = /* @__PURE__ */ new Date();
  const publishedDate = new Date(publishedAt);
  const msPerDay = 24 * 60 * 60 * 1e3;
  const daysAgo = Math.floor((today.getTime() - publishedDate.getTime()) / msPerDay);
  if (daysAgo === 0) {
    return "Today";
  } else if (daysAgo === 1) {
    return "Yesterday";
  } else {
    return `${daysAgo} d. ago`;
  }
};
$:
  formattedDateText = activeSection ? formatDate(activeSection.publishedAt) : "";
</script>

<style>.slider-wrapper {
  display: flex;
  flex-direction: row;
  gap: 4px;
}
.slider-wrapper.horizontal {
  flex-direction: column;
  width: 150px;
}
.slider-container {
  width: 4px;
  height: 150px;
  border-radius: 10px;
  position: relative;
  background-color: hsl(var(--color-N24, var(--color-N20)));
  display: flex;
  flex-direction: column;
}
.slider-container.horizontal {
  flex-direction: row;
  width: 150px;
  height: 4px;
}
.slider-text-container {
  position: relative;
  height: 100%;
  display: flex;
}
.slider-text {
  color: hsl(var(--color-N32));
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Averta, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px;
  position: relative;
  transition: top 0.5s ease;
  writing-mode: vertical-rl;
  text-orientation: mixed;
  transform: rotate(180deg);
}
.slider-text.horizontal {
  transform: rotate(0deg);
  writing-mode: unset;
  text-orientation: mixed;
  transition: left 0.5s ease;
}
.slider {
  background-color: hsl(var(--color-N32));
  width: 100%;
  border-radius: 10px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.25);
  position: absolute;
  transition: top 0.5s ease;
}
.slider.horizontal {
  height: 100%;
  transition: left 0.5s ease;
}
.section-container {
  flex: 1;
  display: flex;
  align-items: center;
}
.section-container.horizontal {
  justify-content: center;
}
.marker {
  width: 100%;
  height: 3px;
  background-color: hsl(var(--color-N32));
  cursor: pointer;
}
.marker.horizontal {
  height: 100%;
  width: 3px;
}</style>

<div class="slider-wrapper" class:horizontal>
  <div class="slider-text-container">
    <div
      class="slider-text"
      class:horizontal
      bind:this={textContainer}
      style="{horizontal ? 'left' : 'top'}: {textContainerPosition}px;">
      {formattedDateText}
    </div>
  </div>
  <div class="slider-container" class:horizontal>
    {#each updatedSectionList as { key, notVisited }}
      <div class="section-container" class:horizontal>
        {#if notVisited}
          <!-- svelte-ignore a11y-click-events-have-key-events -->
          <!-- svelte-ignore a11y-no-static-element-interactions -->
          <div class="marker" class:horizontal on:click={() => onClickSection(key)}></div>
        {/if}
      </div>
    {/each}
    <!-- prettier-ignore -->
    <div
      class="slider"
      class:horizontal
      style="{horizontal ? 'left' : 'top'}: {sliderPosition}px; {horizontal? 'width' : 'height'}: {sliderSize}px;">
    </div>
  </div>
</div>
